module.exports = __webpack_public_path__ + "img/rightArrowCalendar.55393b7d.svg";